import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { StationCameraItem } from '../../models/types/stationCamera';
import { useResponsive } from '../../hooks/mediaQuery';

interface StreamVideoProps {
  isOpen: boolean;
  onClose: () => void;
  camera: StationCameraItem | null;
}

/**
 * Component xem stream video từ camera RTSP (qua server chuyển đổi sang HTTP/HLS/MJPEG).
 * Để xem trực tiếp RTSP trên trình duyệt, cần có server trung gian chuyển đổi (ví dụ: dùng ffmpeg, rtsp-simple-server, hoặc WebRTC gateway).
 */

const DialogIframe: React.FC<StreamVideoProps> = ({ isOpen, onClose, camera }) => {
  const streamUrl = camera?.cameraUrl || '';
  const width = '100%';
  const height = '600';
  const { isXs } = useResponsive();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullScreen={isXs}
      maxWidth="lg"
      fullWidth
      className='dialog_camera'
    >
      <DialogTitle sx={{ m: 0, p: 2, pr: 5 }}>
        {camera?.title || 'Camera'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ background: '#000' }}>
        <iframe src={streamUrl} width={width} height={isXs ? '100%' : height} />
      </DialogContent>
    </Dialog>
  );
};

export default DialogIframe;
